import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LazySrcDirective } from "src/app/share/directives/lazy-src.directive";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { ButtonModule } from "primeng/button";
import { CarouselModule } from "primeng/carousel";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { SelectButtonModule } from "primeng/selectbutton";
import { InputTextareaModule } from "primeng/inputtextarea";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { TabViewModule } from "primeng/tabview";
import { ToastModule } from "primeng/toast";
import { TooltipModule } from "primeng/tooltip";
import { MessageService } from "primeng/api";
import { AppRoutingModule } from "src/app/app-routing.module";
import { TranslocoRootModule } from "src/app/transloco-root.module";
import { DashboardTemplateComponent } from "../dashboard/dashboard-template/dashboard-template.component";
import { SocialFeedComponent } from "./social-feed/social-feed.component";
import { SocialPostCardComponent } from "./social-post-card/social-post-card.component";
import { SocialProfileComponent } from "./social-profile/social-profile.component";
import { SocialExploreDetailComponent } from "./social-explore-detail/social-explore-detail.component";
import { ProjectProfileComponent } from "./project-profile/project-profile.component";
import { SocialReportDialogComponent } from "./social-report-dialog/social-report-dialog.component";
import { SocialBlockDialogComponent } from "./social-block-dialog/social-block-dialog.component";
import { PostImageCropperComponent } from "./post-image-cropper/post-image-cropper.component";
import { AvatarCropperComponent } from "src/app/shared/avatar-cropper/avatar-cropper.component";
import { TimeAgoPipe } from "./pipes/time-ago.pipe";
import { CommunityTabsComponent } from "src/app/share/community-tabs/community-tabs.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { ShareProjectModalModule } from "src/app/shared/share-project-modal/share-project-modal.module";
import { HlsVideoPlayerComponent } from "src/app/share/hls-video-player/hls-video-player.component";

@NgModule({
  declarations: [SocialFeedComponent, SocialPostCardComponent, SocialProfileComponent, SocialExploreDetailComponent, ProjectProfileComponent, SocialReportDialogComponent, SocialBlockDialogComponent, TimeAgoPipe],
  imports: [
    CommonModule,
    LazySrcDirective,
    PostImageCropperComponent,
    AvatarCropperComponent,
    DragDropModule,
    HttpClientModule,
    FormsModule,
    RouterModule,
    AppRoutingModule,
    TranslocoRootModule,
    DashboardTemplateComponent,
    ButtonModule,
    CarouselModule,
    DialogModule,
    DropdownModule,
    SelectButtonModule,
    InputTextareaModule,
    ProgressSpinnerModule,
    TabViewModule,
    ToastModule,
    TooltipModule,
    CommunityTabsComponent,
    ShareProjectModalModule,
    HlsVideoPlayerComponent,
  ],
  providers: [MessageService],
})
export class SocialFeedModule {}
